import React from 'react';
import {bool, func} from 'prop-types';
import {Grid, Icon} from 'semantic-ui-react';
import {EmptyFunc} from 'utils/DBUtils';

export default class PrizeActions extends React.Component {
  static propTypes = {
    prizeCanBeDeleted: bool,
    userCanDeletePrizes: bool,
    onCopyPrize: func.isRequired,
    onDeletePrize: func.isRequired,
  };

  get onDelete() {
    return this.props.prizeCanBeDeleted ? this.props.onDeletePrize : EmptyFunc;
  }

  render() {
    return (
      <Grid className='prize-action-icons'>
        <Grid.Row>
          {this.props.userCanDeletePrizes && (
            <Grid.Column className='action-icon'>
              <Icon
                onClick={this.onDelete}
                name='trash alternate outline'
                disabled={!this.props.prizeCanBeDeleted} />
            </Grid.Column>
          )}
          <Grid.Column className='action-icon'>
            <Icon name='copy' onClick={this.props.onCopyPrize} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/PrizeActions.jsx